import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { useTenantContext } from "../../tenant/TenantContext";

// Rojo fluorescente pedido por dirección para la pastilla del carrito: tiene que verse a la vista
const PILL_STYLE = {
    backgroundColor: "#ff1744",
    color: "#fff",
    fontSize: "0.85rem",
    lineHeight: 1.4
};

/**
 * Aviso para productos bajo pedido con bypass de stock (details.stockBypass):
 * se pueden pedir aunque no haya unidades y la fecha estimada de entrega se
 * consulta por teléfono. El teléfono sale de la config del tenant (cada marca
 * enseña el suyo).
 *
 * variant="info" (por defecto): caja azul de aviso (modal de compra rápida).
 * variant="pill": pastilla roja para la línea del carrito.
 */
export const StockBypassNotice = ({ product, className = "", variant = "info" }) => {
    const { tel } = useTenantContext();
    if (!product?.stockBypass) {
        return null;
    }
    const message = (
        <span>
            Producto bajo pedido: puedes pedirlo aunque no haya stock. Si quieres saber la fecha
            estimada de entrega, llámanos{tel ? <> al <a href={`tel:${tel}`} className={`fw-bold text-nowrap ${variant === "pill" ? "text-white" : ""}`}>{tel}</a></> : null}.
        </span>
    );
    if (variant === "pill") {
        return (
            <span className={`badge rounded-pill text-wrap text-start fw-normal d-inline-flex align-items-center gap-2 py-2 px-3 ${className}`}
                  style={PILL_STYLE}
                  role="status">
                <PhoneInTalkIcon fontSize="small" />
                {message}
            </span>
        );
    }
    return (
        <div className={`alert alert-info d-flex align-items-center gap-2 py-2 ${className}`} role="status">
            <PhoneInTalkIcon fontSize="small" />
            {message}
        </div>
    );
};
